import React from "react";
import { Link } from "react-router-dom";

import "./privacy_policy_page.css";

import TermlyPolicyEmbed from "../components/TermlyPolicyEmbed";
import Logo from "../assets/composiq-mark-128.png";

const TERMLY_PRIVACY_POLICY_ID = "bb93cf9c-19c1-4c44-88c4-608d544b67b9";

export default function PrivacyPolicyPage(){
  const [mobileOpen, setMobileOpen] = React.useState(false);

  return (
    <div className="App">
      {/* ───────── HEADER (match Home) ───────── */}
      <header className="dbx-header" role="banner">
        <div className="dbx-header-inner">
          <Link to="/" className="dbx-brand" aria-label="Zerivo home">
            <img className="dbx-brand-mark" src={Logo} alt="" />
            <div className="dbx-brand-text-group">
              <span className="dbx-brand-text">Zerivo</span>
              <span className="dbx-brand-subtitle">Private AI</span>
            </div>
          </Link>

          <nav className="dbx-header-nav" aria-label="Main navigation">
            <Link to="/our-team">Our Team</Link>
            <Link to="/contact">Contact</Link>
          </nav>

        </div>
      </header>

      {mobileOpen && (
        <nav className="dbx-mobile-nav" role="navigation" aria-label="Mobile navigation">
          <button className="dbx-mobile-close" onClick={() => setMobileOpen(false)} aria-label="Close menu">×</button>
          <Link to="/our-team" onClick={() => setMobileOpen(false)}>Our Team</Link>
          <Link to="/contact" onClick={() => setMobileOpen(false)}>Contact</Link>
          <Link to="/privacy" onClick={() => setMobileOpen(false)}>Privacy</Link>
          <Link to="/terms" onClick={() => setMobileOpen(false)}>Terms</Link>
        </nav>
      )}
      {mobileOpen && <div className="dbx-mobile-backdrop" onClick={() => setMobileOpen(false)} aria-hidden="true"></div>}

      {/* ───────── MAIN CONTENT ───────── */}
      <main className="privacy-wrapper">
        <h1 className="privacy-title">Privacy Policy</h1>
        <p className="privacy-intro">
          Your privacy matters to us. This page explains what data we collect, how we use it,
          and the choices you have.
        </p>

        <TermlyPolicyEmbed
          policyId={TERMLY_PRIVACY_POLICY_ID}
          policyName="privacy policy"
        />
      </main>
    </div>
  );
}
